import type { FandomTaxonomyValue, WindowFandomTaxonomy } from "./types";

// let's declare that window object has a property called fandomTaxonomy of type WindowFandomTaxonomy
declare global {
  interface Window {
    fandomTaxonomy?: WindowFandomTaxonomy;
  }
}

// Normalize the confidence score to a string c0..c9
export function normalizeConfidenceScore(confidence: number): string {
  if (typeof confidence !== "number" || isNaN(confidence)) {
    return "";
  }
  const newConf = Math.floor(confidence * 10);
  return `_c${0 + newConf}`;
}

// This function is used to filter out empty values from the object
export function filterValues(
  o: Record<string, string[]>,
): Record<string, string[]> {
  if (typeof o !== "object" || o === null) {
    return o;
  }

  return Object.keys(o).reduce(
    (acc, key) => {
      if (o[key] && o[key].length > 0) {
        acc[key] = o[key];
      }
      return acc;
    },
    {} as Record<string, string[]>,
  );
}

// filter out values that are not objects, or do not have a value string, or have an empty value string
export function validFandomTaxonomyValue(value: FandomTaxonomyValue): boolean {
  return (
    typeof value === "object" &&
    value &&
    typeof value.value === "string" &&
    value.value.length > 0 &&
    typeof value.confidence === "number"
  );
}
